"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeVacationForm = void 0;
const ui_1 = require("@app/component/ui");
const data_grid_1 = require("@app/component/ui/data-grid");
const forms_1 = require("@app/component/ui/forms");
const time_input_1 = require("@app/component/ui/forms/time-input/time-input");
const Tooltip_1 = require("@app/component/ui/tooltip/Tooltip");
const util_1 = require("@app/util");
const filtered_content_for_organization_1 = require("@app/util/filtered-content-for-organization");
const format_hours_1 = require("@app/util/format-hours");
const useWorkspace_1 = require("@app/util/hooks/useWorkspace");
const react_1 = __importDefault(require("react"));
const EmployeeVacationForm = ({ editing, setEditing, fields, control, isReadOnly, }) => {
    const workspace = (0, useWorkspace_1.useWorkspace)();
    const displayVacationAsDays = workspace?.displayVacationsAsDays;
    // True (Sportisimo Logistika) -> form is editable, but only external (disable all other fields)
    // False (everyone else) -> form is editable - all fields
    const vacationEditableOnlyForExternal = (0, filtered_content_for_organization_1.getFilteredContentForOrganization)('vacation_editable_only_for_external', false, undefined);
    const vacationGridColumns = fields.reduce((acc, curr, index) => {
        if (index % 2 === 0) {
            acc.left.push(curr);
        }
        else {
            acc.right.push(curr);
        }
        return acc;
    }, { left: [], right: [] });
    const displayEditButton = !editing.includes('vacation') && !isReadOnly;
    const disableEditButton = fields.length === 0;
    console.log(fields);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { style: { display: 'flex', justifyContent: 'space-between' } },
            react_1.default.createElement(ui_1.Text, { weight: 'bold', text: (0, util_1.t)('UNAV_VACATION') }),
            displayEditButton && (react_1.default.createElement(ui_1.Button, { ico: 'edit', style: 'BORDERLESS', onClick: () => setEditing('vacation'), disabled: disableEditButton }, (0, util_1.t)('EDIT')))),
        react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_8, type: ui_1.Spacing.TYPES.VERTICAL }),
        !editing.includes('vacation') && (react_1.default.createElement(data_grid_1.DataGrid, { columns: [
                {
                    cells: vacationGridColumns.left.map((ct) => ({
                        label: ct?.contract.id === 'external' ? (react_1.default.createElement("div", { style: { display: 'flex', gap: '1rem' } },
                            react_1.default.createElement(ui_1.Text, { color: 'inherit', weight: 'bold' }, ct?.contract?.name?.toUpperCase()),
                            ' ',
                            react_1.default.createElement(Tooltip_1.Tooltip, { anchor: react_1.default.createElement(ui_1.Icon, { ico: 'info' }) }, (0, util_1.t)('WARNING_EXTERNAL_CONTRACT')))) : ((ct?.contract?.name ?? '')),
                        value: displayVacationAsDays
                            ? `${(ct?.amount ?? 0).toString()} ${(0, util_1.t)('DAYS_COUNT')}`
                            : (0, format_hours_1.formatHours)((ct?.amount ?? 0) / 60),
                    })),
                },
                {
                    cells: vacationGridColumns.right.map((ct) => ({
                        label: ct?.contract?.name ?? '',
                        value: displayVacationAsDays
                            ? `${(ct?.amount ?? 0).toString()} ${(0, util_1.t)('DAYS_COUNT')}`
                            : (0, format_hours_1.formatHours)((ct?.amount ?? 0) / 60),
                    })),
                },
            ] })),
        editing.includes('vacation') && (react_1.default.createElement("div", { style: {
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                width: '100%',
                gap: '1rem',
            } }, fields.map((field, index) => displayVacationAsDays ? (react_1.default.createElement(forms_1.NumberInput, { label: field.contract?.name, key: field.id, control: control, name: `vacations.${index}.amount`, extraContent: (0, util_1.t)('DAYS_COUNT'), disabled: field.contract.id.toLowerCase().trim() !== 'external' &&
                vacationEditableOnlyForExternal })) : (react_1.default.createElement(time_input_1.TimeInput, { maxHours: 999, label: field.contract?.name, key: field.id, control: control, name: `vacations.${index}.amount`, disabled: field.contract.id.toLowerCase().trim() !== 'external' &&
                vacationEditableOnlyForExternal })))))));
};
exports.EmployeeVacationForm = EmployeeVacationForm;
